import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import Chart from './MarblesChart.d3.js'
import ChartWrapper from '../ChartWrapper'

const MarblesChart = ({ tickers, group, isEmptyData, riskType }) => {
  const history = useHistory()
  const updateProps = useMemo(
    () => ({
      group,
      riskType,
      data: tickers,
    }),
    [group, riskType, tickers],
  )

  return (
    <div style={{ height: isMobile ? '350px' : '500px' }}>
      <ChartWrapper
        Chart={Chart}
        initProps={{
          data: tickers,
          redirect: history.push,
          group,
          isEmptyData,
          riskType,
        }}
        updateProps={updateProps}
        margin={{ TOP: 10, BOTTOM: 10, LEFT: 10, RIGHT: 10 }}
      />
    </div>
  )
}
export default MarblesChart
